import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/core/helper/common.service';

@Component({
  selector: 'app-profile-layout',
  templateUrl: './profile-layout.component.html',
  styleUrls: ['./profile-layout.component.scss'],
  host:{
    "[attr.tabindex]": "-1", 
  }
})
export class ProfileLayoutComponent implements OnInit {

  constructor(private fb: UntypedFormBuilder, private commonService : CommonService) { }

  
  // languageForm: FormGroup;
  language = 'en';
  languages = [
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'fr', name: 'French' },
    { id: 'ar', name: 'Arabic' },
    { id: 'ru', name: 'Russian'}
  ];

  ngOnInit(): void {
  }

  changeLang(){
    // console.log('===========change language======', this.language)
    this.commonService.changeLanguage(this.language)
  }

}
